export default "__VITE_ASSET__Bf6DLeVn__ 480w, __VITE_ASSET__B6MVcYQU__ 768w, __VITE_ASSET__5pWxWw0v__ 1200w, __VITE_ASSET__gfjdJ$2e__ 1920w";